import {DI_TOKENS} from '../di/di.tokens';

import {injected} from 'brandi';

import {GlobalWindow} from '../types';

export class Vibration {
  constructor(private readonly globalWindow: GlobalWindow) {}

  public vibrate(volume: number | number[]): void {
    this.globalWindow.navigator?.vibrate?.(volume);
  }
}

injected(Vibration, DI_TOKENS.globalWindow);
